import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const HERO = "https://static.prod-images.emergentagent.com/jobs/5b928005-80ef-4492-8fe9-a327e4efb087/images/203ed08b4e6c446bbc4b29413833a9c90ab7cdb0cc8cb77ac4a3eb8de120c02f.jpeg";

// Deterministic white specks that drift up out of the wordmark.
const SPECKS = Array.from({ length: 30 }).map((_, i) => ({
  id: i,
  left: 50 + (((i * 53) % 100) - 50) * 0.9, // clustered around centre, %
  size: 1 + (i % 3),
  delay: (i % 15) * 0.4,
  dur: 3.4 + (i % 6) * 0.6,
  dx: (((i * 41) % 100) - 50) * 1.4, // horizontal drift px
  rise: 150 + (i % 5) * 60,
}));

export default function Home() {
  const nav = useNavigate();
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-6 py-10 overflow-hidden" data-testid="home-page">
      <div className="relative flex flex-col items-center">
        <img src={HERO} alt="Gaelic footballer leaping to catch" data-testid="home-catcher"
          className="h-[46vh] sm:h-[56vh] max-h-[600px] w-auto object-contain [mix-blend-mode:screen] gp-rise" draggable="false" />

        {/* white specks rising from the wordmark */}
        <div className="pointer-events-none absolute left-0 right-0 bottom-16 sm:bottom-20 h-[60vh] overflow-visible" aria-hidden="true">
          {SPECKS.map((s) => (
            <span key={s.id} className="gp-speck" style={{
              left: `${s.left}%`, width: s.size, height: s.size,
              animationDelay: `${s.delay}s`, animationDuration: `${s.dur}s`,
              "--dx": `${s.dx}px`, "--rise": `-${s.rise}px`,
            }} />
          ))}
        </div>

        <h1 className="font-display font-extrabold text-white text-6xl sm:text-7xl lg:text-8xl tracking-tight leading-none -mt-2 relative z-10" data-testid="home-wordmark">GaaPlay</h1>
        <button data-testid="home-cta-start" onClick={() => nav(user ? "/teams" : "/login")}
          className="mt-9 rounded-full bg-white text-black font-bold text-sm px-9 py-3 hover:bg-white/90 active:scale-95 transition-all relative z-10">
          {user ? "My teams" : "Log in"}
        </button>
      </div>

      <style>{`
        .gp-rise{ animation: gpRise 1.1s cubic-bezier(.22,1,.36,1) both, gpFloat 4.5s ease-in-out 1.1s infinite; }
        @keyframes gpRise{ from{ opacity:0; transform:translateY(38%) scale(.98);} to{ opacity:1; transform:translateY(0) scale(1);} }
        @keyframes gpFloat{ 0%,100%{ transform:translateY(0);} 50%{ transform:translateY(-2%);} }
        .gp-speck{ position:absolute; bottom:0; border-radius:9999px; background:#fff;
          box-shadow:0 0 6px 1px rgba(255,255,255,.7); opacity:0; animation-name:gpSpeck;
          animation-timing-function:ease-out; animation-iteration-count:infinite; }
        @keyframes gpSpeck{
          0%{ opacity:0; transform:translate(0,10px) scale(.6);}
          12%{ opacity:.95;}
          70%{ opacity:.55;}
          100%{ opacity:0; transform:translate(var(--dx), var(--rise)) scale(1);}
        }
        @media (prefers-reduced-motion: reduce){ .gp-rise{ animation:none; } .gp-speck{ display:none; } }
      `}</style>
    </div>
  );
}
